import Glide from '@glidejs/glide';

export default {
  init() {
    // JavaScript to be fired on the about us page

    $(function() { 

      $(window).on( 'resize', () => {
        updateHoverSpacing();
      });

      let resetHoverSpacing = () => {
        $('.section--hover-hanging').removeAttr('style');
        $('.section--before-hover').removeAttr('style');
        $('.section--after-hover').removeAttr('style');
      };

      let setHoverSpacing = () => {
        $('.section--hover-hanging').css({
          'margin-top': '-' + $('.section--hover-hanging').outerHeight()*2/3 + 'px',
          'margin-bottom': '-' + $('.section--hover-hanging').outerHeight()*1/3 + 'px',
        });
  
        $('.section--before-hover').css({
          'padding-bottom': $('.section--hover-hanging').outerHeight()*2/3 + 100 +'px',
        });
  
        $('.section--after-hover').css({
          'padding-top': $('.section--hover-hanging').outerHeight()*1/3 + 100 +'px',
        });
      };

      let updateHoverSpacing = () => {
        if ($(window).width() >= 960) {
          setHoverSpacing();
        } else {
          resetHoverSpacing();
        }
      };

      updateHoverSpacing();

      const gliders = document.querySelectorAll('.basic-glide');
      gliders.forEach(glide => {
        new Glide(glide, {
          type: 'carousel',
          autoplay: 6000,
        }).mount();
      });

      const paginationBtn = $('.show-more-btn');

      if (paginationBtn) {
        paginationBtn.on('click', function(e) {
          e.preventDefault();

          let content = $(paginationBtn).closest('.col--section').find('.enable-pagination');

          // console.log(content);

          $(content).children('.hide-col').each(function(i, e) {
            // console.log(e);
            $(e).removeClass('hide-col');
          });
        });
      }

    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/landing.js